import { render, staticRenderFns } from "./UserNeedSign.vue?vue&type=template&id=0edc72c8&scoped=true&"
import script from "./UserNeedSign.vue?vue&type=script&lang=js&"
export * from "./UserNeedSign.vue?vue&type=script&lang=js&"
import style0 from "./UserNeedSign.vue?vue&type=style&index=0&id=0edc72c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edc72c8",
  null
  
)

export default component.exports